import Layout from "@/layout/index.vue";

export default [
  // FS管理
  {
    path: "/fs",
    name: "fs",
    component: Layout,
    redirect: "/fs/whole-flow",
    meta: {
      title: "FS配置",
    },
    children: [
      // {
      //   path: "/fs/whole-flow",
      //   name: "fsWholeFlow",
      //   component: () =>
      //     import("@/views/fs/pages/whole-flow/index.vue"),
      //   meta: {
      //     title: "整体流程",
      //     newPage: true,
      //   },
      // },
      {
        path: "/fs/line-config",
        name: "fsLineConfig",
        component: () =>
          import("@/views/fs/pages/line-config/index.vue"),
        meta: {
          title: "线路配置",
          newPage: true,
        },
      },
      {
            path: "/fs/concurrence-config",
            name: "fsConcurrenceConfig",
            component: () =>
                import("@/views/fs/pages/concurrence-config/index.vue"),
            meta: {
                title: "神都计划并发配置",
                newPage: true,
            },
      },
      {
        path: "/fs/script-divide",
        name: "fsScriptDivide",
        component: () => import("@/views/fs/pages/script-divide/index.vue"),
        meta: {
          title: "剧本分流配置",
          newPage: true,
        },
      },
      {
        path: "/fs/line-online-stats",
        name: "fsLineOnlineStats",
        component: () =>
          import("@/views/fs/pages/line-online-stats/index.vue"),
        meta: {
          title: "线路检测实时报表",
          newPage: true,
        },
      },
      {
        path: "/fs/line-call-reconciliation-month-stats",
        name: "fsLineCallReconciliationMonthStats",
        component: () =>
          import("@/views/fs/pages/line-call-reconciliation-month-stats/index.vue"),
        meta: {
          title: "线路通话对账月报",
          newPage: true,
        },
      },
      {
        path: "/fs/line-call-duration",
        name: "fsLineCallDuration",
        component: () =>
          import("@/views/fs/pages/line-call-duration/index.vue"),
        meta: {
          title: "线路外呼分钟数查询",
          newPage: true,
        },
      },
      {
        path: "/fs/line-concurrence-config",
        name: "fsLineConcurrenceConfig",
        component: () =>
          import("@/views/fs/pages/line-concurrence-config/index.vue"),
        meta: {
          title: "线路并发配置",
          newPage: true,
        },
      },
      {
        path: "/fs/lx-sms-divide",
        name: "lxSmsDivide",
        component: () =>
          import("@/views/fs/pages/lx-sms-divide/index.vue"),
        meta: {
          title: "零犀短信分流配置",
          newPage: true,
        },
      },

    ],
  },
]
